import React from 'react';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';

const iconStyles = xcss({
	width: '22px',
	height: '22px',
});

export const GoogleDriveIcon: () => React.JSX.Element = () => (
	<Box xcss={iconStyles}>
		<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect x="1" y="1" width="20" height="20" rx="4" fill="white" />
			<rect
				x="0.618757"
				y="0.618757"
				width="20.7625"
				height="20.7625"
				rx="4.38124"
				stroke="#0B1228"
				strokeOpacity="0.14"
				strokeWidth="0.762486"
			/>
			<g clipPath="url(#clip0_931_182)">
				<path
					d="M4.20962 16.0782L4.91523 17.2907C5.06186 17.546 5.27262 17.7466 5.52005 17.8925L8.04009 13.5529H3C3 13.8355 3.07331 14.1181 3.21993 14.3734L4.20962 16.0782Z"
					fill="#0066DA"
				/>
				<path
					d="M11 8.44751L8.47995 4.10791C8.23253 4.25378 8.02176 4.45435 7.87514 4.70962L3.21993 12.7324C3.07601 12.9822 3.00019 13.265 3 13.5529H8.04009L11 8.44751Z"
					fill="#00AC47"
				/>
				<path
					d="M16.4799 17.8925C16.7273 17.7466 16.9381 17.546 17.0847 17.2907L17.3779 16.7893L18.78 14.3734C18.9266 14.1181 18.9999 13.8355 18.9999 13.5529H13.9595L15.032 15.6497L16.4799 17.8925Z"
					fill="#EA4335"
				/>
				<path
					d="M11 8.4475L13.5201 4.1079C13.2726 3.96203 12.9886 3.8891 12.6953 3.8891H9.30472C9.01148 3.8891 8.7274 3.97115 8.47998 4.1079L11 8.4475Z"
					fill="#00832D"
				/>
				<path
					d="M13.9594 13.5529H8.03958L5.51953 17.8925C5.76695 18.0383 6.05103 18.1113 6.34427 18.1113H15.6547C15.9479 18.1113 16.232 18.0292 16.4794 17.8925L13.9594 13.5529Z"
					fill="#2684FC"
				/>
				<path
					d="M16.4525 8.72101L14.1249 4.70962C13.9782 4.45435 13.7675 4.25378 13.52 4.10791L11 8.44751L13.9599 13.5529H18.9908C18.9908 13.2703 18.9175 12.9877 18.7709 12.7324L16.4525 8.72101Z"
					fill="#FFBA00"
				/>
			</g>
			<defs>
				<clipPath id="clip0_931_182">
					<rect width="16" height="14.2222" fill="white" transform="translate(3 3.88904)" />
				</clipPath>
			</defs>
		</svg>
	</Box>
);
